import styled from "@emotion/styled";
// eslint-disable-next-line no-restricted-imports
import { Text as RadixText, type TextProps as RadixTextProps } from "@radix-ui/themes";
import type React from "react";
import type { CSSProperties, PropsWithChildren } from "react";

import type { ColorTypes } from "@themes/colors";
import { theme } from "@themes/themes";

export interface TextProps extends Omit<RadixTextProps, "color" | "as">, PropsWithChildren<unknown> {
  color?: ColorTypes;
  font?: keyof typeof theme.font;
  mono?: boolean;
  transform?: CSSProperties["textTransform"];
}

export const Text: React.FC<TextProps> = ({ color, font, mono, children, transform, ...rest }) => {
  return (
    <StyledText data-color={color} data-font={font} data-mono={mono} data-transform={transform} {...rest}>
      {children}
    </StyledText>
  );
};

const StyledText = styled(RadixText)<{
  "data-color"?: ColorTypes;
  "data-font"?: keyof typeof theme.font;
  "data-mono"?: boolean;
  "data-transform"?: CSSProperties["textTransform"];
}>`
  ${({ "data-font": dataFont }) => dataFont && theme.font[dataFont]};
  ${({ "data-mono": dataMono }) => dataMono && 'font-family: "IBM Plex Mono", monospace;'};
  text-transform: ${({ "data-transform": dataTransform }) => dataTransform || "inherit"};
  color: ${({ "data-color": dataColor }) => (dataColor ? theme.color(dataColor) : theme.color("accent-contrast"))};
`;
